import instance from './apiHeader'
import BaseURL from './baseURL'

const login = async (username, password) => {
  return await instance.post(BaseURL.appURL() + `/auth/login`, {
    username: username,
    password: password,
  })
}

const menu = async () => {
  return await instance.post(BaseURL.appURL() + `/user/myMenu`, {})
}

const info = async () => {
  return await instance.post(BaseURL.appURL() + `/user/info`, {})
}

const logout = async () => {
  return await instance.get(BaseURL.appURL() + `/auth/logout`)
}


const loginApi = {
  login,
  menu,
  info,
  logout
}

export default loginApi
